export default __webpack_public_path__ + "static/media/MainMenuLoop.e960751b.mp3";